import { clearStoredValue } from 'utils/storage';

import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'checkout',
  initialize() {
    this.plan = JSON.parse(clearStoredValue('epsubplan')) || {};
  },
  context() {
    return {
      planQuantity: this.plan.quantity,
      planInterval: this.plan.interval,
      planName: this.plan.name,
      planPrice: this.plan.price,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/checkout/success/index.js